import api from './api';

export interface BankOperation {
  id: number;
  operationRef: string | null;
  invoice_id: number | null;
  type: 'wyplata' | 'wplata';
  status: 'niezrealizowane' | 'zrealizowane' | 'uzgodnione';
  operationDate: string | null;
  contractor: string | null;
  nip: string | null;
  transferTitle: string | null;
  paymentType: string | null;
  projectCode: string | null;
  grossAmount: number;
  vatAmount: number;
  netAmount: number;
  currency: string;
  amountFromVatAccount: number;
  contractorAccount: string | null;
  unitrescoAccount: string | null;
  statementNumber: string | null;
  realizedAt: string | null;
  reconciledAt: string | null;
  settledByUserId: string | null;
  note: string | null;
  reconciliationBankName: string | null;
  reconciliationStatementNumber: string | null;
  reconciliationStatementDate: string | null;
  reconciliationTransactionId: number | null;
  createdAt: string;
  invoiceNumber: string | null;
}

export async function listBankOperations(): Promise<BankOperation[]> {
  const { data } = await api.get('/bank-operations');
  return data?.data || [];
}

export async function updateBankOperationStatus(id: number | string, status: 'niezrealizowane' | 'zrealizowane' | 'uzgodnione'): Promise<void> {
  await api.patch(`/bank-operations/${id}/status`, { status });
}

export async function updateBankOperation(id: number | string, payload: { statement_number?: string; note?: string }): Promise<void> {
  await api.patch(`/bank-operations/${id}`, payload);
}

export async function deleteBankOperation(id: number | string): Promise<void> {
  await api.delete(`/bank-operations/${id}`);
}

export async function exportMbank(ids: (number | string)[]): Promise<Blob> {
  const { data } = await api.post('/bank-operations/export-mbank', { ids }, { responseType: 'blob' });
  return data;
}
